import React from 'react';
import { Card, Empty } from 'antd';
import moment from 'moment';
import {
  ResponsiveContainer,
  AreaChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Area,
} from 'recharts';

const AccountTypeChart = ({ data }) => {
  const maxVal = Math.max(...data.map(d => Math.max(d.paid, d.trial, d.total)), 1000);
  let yMax = 1000;
  if (maxVal > 0) {
    if (maxVal <= 1000) yMax = 1000;
    else if (maxVal <= 2000) yMax = 2000;
    else if (maxVal <= 5000) yMax = 5000;
    else if (maxVal <= 10000) yMax = 10000;
    else yMax = Math.ceil(maxVal / 10000) * 10000;
  }

  const formatDate = (dateStr) => {
    const date = moment(dateStr);
    const day = date.date();
    return day % 5 === 0 || day === date.daysInMonth() ? day.toString() : '';
  };

  return (
    <Card className="side-panel align-center" style={{ minHeight: '500px' }}>
      {data.length ? (
        <ResponsiveContainer>
          <AreaChart data={data} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" tickFormatter={formatDate} interval={0} />
            <YAxis domain={[0, yMax]} tickFormatter={v => v >= 1000 ? `${v / 1000}k` : v} />
            <Tooltip formatter={(value, name) => [value, name]} />
            <Area type="monotone" dataKey="free" stroke="#8884d8" fillOpacity={0.2} />
            <Area type="monotone" dataKey="paid" stroke="#6366f1" fillOpacity={0.2} />
            <Area type="monotone" dataKey="trial" stroke="#60a5fa" fillOpacity={0.2} />
          </AreaChart>
        </ResponsiveContainer>
      ) : <Empty />}
    </Card>
  );
};

export default AccountTypeChart;
